import { ReactNode } from 'react'

import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { analyticsNumberFormatter } from '../../utils/parser.js'

interface EventListItemProps {
  title?: ReactNode
  value?: number | string
  onClick: () => void
}

export const EventListItem = ({
  title,
  value,
  ...props
}: EventListItemProps) => {
  return (
    <div
      className="flex items-center justify-between space-s-3 px-3 py-2 rounded-base cursor-pointer hover:bg-surface-hovered hover:text-content"
      {...props}
    >
      <div className="flex-1 flex items-center space-s-3 text-content-subdued truncate">
        <div className="flex shrink-0 justify-center items-center rounded-avatar text-surface w-8 h-8 bg-decorative-surface-3">
          <SvgIcon className="w-5 h-5" name="calendar" />
        </div>
        <div className="truncate">{title}</div>
      </div>
      <div className="text-content">{analyticsNumberFormatter(value)}</div>
    </div>
  )
}
